<template>
  <node-view-wrapper
    as="span"
    class="blip-token-chip"
    :class="{ 'is-selected': selected }"
    contenteditable="false"
  >
    <span class="blip-token-chip__label">{{ label }}</span>
    <button
      v-if="editor && editor.isEditable"
      type="button"
      class="blip-token-chip__remove"
      title="토큰 삭제"
      @click="deleteNode"
    >
      ×
    </button>
  </node-view-wrapper>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { NodeViewWrapper, nodeViewProps } from "@tiptap/vue-2";
import { FUNDING_TOKENS } from "@space-oddity-inc/editor-core";

export default defineComponent({
  name: "TokenChip",
  components: { NodeViewWrapper },
  props: nodeViewProps,
  computed: {
    tokenKey(): string {
      return String(this.node.attrs.key ?? "");
    },
    label(): string {
      const def = FUNDING_TOKENS.find((t) => t.key === this.tokenKey);
      return def ? def.label : this.tokenKey;
    },
  },
});
</script>

<style scoped>
.blip-token-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 1px 6px;
  margin: 0 1px;
  border-radius: 10px;
  background: #eef2ff;
  color: #3730a3;
  font-size: 0.85em;
  line-height: 1.4;
  white-space: nowrap;
  user-select: none;
}
.blip-token-chip.is-selected {
  outline: 2px solid #6366f1;
}
.blip-token-chip__remove {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0 0 0 2px;
  font-size: 1em;
  line-height: 1;
}
</style>
